module.exports = __webpack_public_path__ + "img/logomarca_appembarque_white.b7dbdc53.png";